export const formatDateTime = (iso?: string | null) =>
  iso
    ? new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })
    : '—';
